export function getErrorMessage(error: any): string {
  if (error?.response?.data?.erro) {
    const erro = error.response.data.erro;
    if (error.response.data?.campos) {
      const campos = error.response.data.campos;
      const detalhes = Object.entries(campos)
        .map(([campo, msg]) => `${msg}`)
        .join('; ');
      return `${erro}. ${detalhes}`;
    }
    return erro;
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (error?.message) {
    return error.message;
  }
  return 'Ocorreu um erro inesperado. Tente novamente.';
}
